(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_footer-policy-list"] && !Shopify.designMode) return;
  try {
    let rdbPreferencesOpening = false;

  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('[data-rdb-cookie-preferences]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (typeof window.privacyBanner?.showPreferences !== 'function') return;

    event.preventDefault();
    if (rdbPreferencesOpening) return;
    rdbPreferencesOpening = true;

    // Shopify restores focus to this invoker when its native dialog closes.
    link.focus({ preventScroll: true });
    try {
      await window.privacyBanner.showPreferences();
    } catch {
      // The native privacy policy remains usable if the banner cannot load.
      window.location.assign(link.href);
    } finally {
      rdbPreferencesOpening = false;
    }
  });
  } catch(e) { console.error(e); }
})();

})();
